// src/components/ui/OptimizedImage.tsx
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { motion } from 'framer-motion';

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  withAnimation?: boolean;
  animationProps?: Record<string, unknown>;
}

export function OptimizedImage({
  src,
  alt,
  width,
  height,
  className,
  priority = false,
  withAnimation = false,
  animationProps = {},
}: OptimizedImageProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  const imageElement = (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      onLoad={() => setIsLoaded(true)}
      className={cn(
        'transition-opacity duration-300',
        !isLoaded ? 'opacity-0' : 'opacity-100',
        className,
      )}
    />
  );

  // Render with or without animation wrapper based on props
  if (withAnimation) {
    return <motion.div {...animationProps}>{imageElement}</motion.div>;
  }

  return imageElement;
}

export default OptimizedImage;
